import React, { PureComponent } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import { numberWithCommas } from "../../../../../Dashboard/utils";

class FollowersLostAndGainChart extends PureComponent {
    constructor(props) {
        super(props);

        this.chartComponent = React.createRef();
        this.state = {
            rerender: 0,
        };
    }

    componentDidMount() {
        // if (!this.props.isTWPage) {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent.current?.chart?.setSize(null, null);
                this.chartComponent.current?.chart?.reflow();
            }, 0);
        });

        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        } else {
            this.setState({ rerender: this.state.rerender + 1 });
        }
        // }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.rerender) {
            if (this.props.widgetContainerRef?.current) {
                this.ro.observe(this.props.widgetContainerRef?.current);

                this.setState({ rerender: 0 });
            } else if (prevState.rerender !== this.state.rerender) {
                setTimeout(() => {
                    this.setState({ rerender: this.state.rerender + 1 });
                }, 100);
            }
        }
    }

    componentWillUnmount() {
        // if (!this.props.isTWPage) {
        this.ro.disconnect();
        // }
    }

    getOptions = () => {
        if (this.props.graph_type == "line") return this.getLineOptions();
        else return this.getBarOptions();
    };

    getLineOptions = () => {
        let x = this.props.data;
        let totalFollowersCount = [];
        let postiveFollowers = [];
        let negativeFollowers = [];

        x?.data?.forEach((obj) => {
            let totalFollObj = {
                x: obj.x,
                y: obj.colorIndex,
            };
            let gainObj = {
                x: obj.x,
                y: obj.y,
            };

            let lostObj = {
                x: obj.x,
                y: obj.y,
            };
            totalFollowersCount.push(totalFollObj);

            if (obj.y >= 0) {
                lostObj.y = 0;
                postiveFollowers.push(gainObj);
                negativeFollowers.push(lostObj);
            } else {
                gainObj.y = 0;
                postiveFollowers.push(gainObj);
                negativeFollowers.push(lostObj);
            }
        });

        // let x = {
        //     data: [
        //         [1647993600000, -5],
        //         [1648993600000, 5],
        //         [1649993600000, -6],
        //     ],
        // };

        // let positive = x.data.filter((array) => array[1] >= 0);
        // let negative = x.data.filter((array) => array[1] < 0);

        const height = this.props.isTWPage ? "338px" : null;
        const legendAlign = this.props.isTWPage ? "right" : "center";

        const pageViewConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: null,
                    marker: {
                        enabled: true,
                        radius: 2,
                    },
                },
            },
            chart: {
                type: "spline",
                className: "skiptranslate",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                height,
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                enabled: this.props.showLegend,
                alignColumns: false,
                align: legendAlign,
            },
            noData: {
                position: {
                    align: "center",
                },
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                // min: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                // formatter: function () {
                //     return `<span>${moment(this.x).startOf("day").format("LLLL")}</span>
                //     <br/><span>${this.series.name}: <b>${this.y >= 1 ? numberWithCommas(this.y) : 0}</b></span><br/><span>Lost
                //     : <b>${this.y < 0 ? numberWithCommas(this.y) : 0}</b></span><br/><span>Total Followers: <b>${numberWithCommas(this.colorIndex)}</b></span>`;
                // },
                formatter: function () {
                    return `<span>${moment(this.x).startOf("day").format("LLLL")}</span>
                    <br/><span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span>`;
                },
            },
            series: [
                { color: "#f7c377", name: "Total Followers", data: totalFollowersCount },
                { color: "#66ff9e", name: "Gain", data: postiveFollowers },
                { color: "#ff5e5e", name: "Lost", data: negativeFollowers },
            ],
            time: {
                useUTC: false,
            },
        };

        return pageViewConfig;
    };

    getBarOptions = () => {
        let x = this.props.data;

        let positive = x.data.filter((obj) => obj.y >= 0);
        let negative = x.data.filter((obj) => obj.y <= 0);

        const height = this.props.isTWPage ? "338px" : null;
        const legendAlign = this.props.isTWPage ? "right" : "center";

        const pageViewColumnConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: "normal",
                },
            },
            chart: {
                type: "column",
                height,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                // min: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            lang: {
                noData: "No Data.",
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).startOf("day").format("LLLL")}</span>
                    <br/> <span>${this.series.name}: <b>${numberWithCommas(this.y)}</b></span><br/><span>${
                        this.series.name === "Gain" ? "Lost" : "Gain"
                    }: <b>0</b></span><br/><span>Total Followers: <b>${numberWithCommas(this.colorIndex)}</b></span>`;
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    paddingTop: "10px",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                paddingTop: 18,
                align: legendAlign,
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                { color: "#66ff9e", name: "Gain", data: positive },
                { color: "#ff5e5e", name: "Lost", data: negative },
            ],
            time: {
                useUTC: false,
            },
        };

        return pageViewColumnConfig;
    };

    render() {
        return (
            <>
                {!this.props.isNoData() && !this.props.error ? (
                    <>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOptions()}
                            ref={this.chartComponent}
                            containerProps={!this.props.isTWPage && { style: { width: "100%", height: "calc(100% - 20px)" } }}
                        />
                    </>
                ) : (
                    <NoData message={this.props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                )}
            </>
        );
    }
}

export default FollowersLostAndGainChart;
